import { Download } from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'
import { useRef, useState } from 'react'
import { DownloadMenu } from '@/features/search/SearchResults/actions/DownloadMenu'
import type { PreviewButtonProps } from './Buttons'

export const DownloadButton = (props: PreviewButtonProps) => {
  const { mediaCode, fileAttachments } = props.searchResultItem
  const ref = useRef(null)
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="Download" placement="top">
        <Button color="info" ref={ref} onClick={() => setOpen(true)}>
          <Download />
        </Button>
      </Tooltip>

      <DownloadMenu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={ref.current}
        mediaCode={mediaCode}
        files={fileAttachments}
      />
    </>
  )
}
